module.exports = __webpack_public_path__ + "sharp-sans-bold-italic-08c2370fddbc8ea37bc052bdf73b88d9.bundle.woff";